import { Expose, Type } from 'class-transformer'

import { BookmarkChapterType } from './BookmarkChapterType'

export class BookmarkType {
  @Expose() id: number

  @Expose({ name: 'bookChapter' })
  @Type(() => BookmarkChapterType)
  chapter: BookmarkChapterType

  @Expose() createdAt: string
}
